















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import types from './type'

@Component({})
export default class ExceptionPage extends Vue {
	@Prop({
		type: String,
		default: '404',
	})
	public type!: string

	private config: any = types

	private handleToHome() {
		this.$store.dispatch('user/Logout').then(() => {
			window.location.replace(`${location.origin}/passport/login`)
		})
	}
}
